var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttention(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.22686 18.5218L10.5396 2.82634C10.6868 2.57528 10.8995 2.36664 11.1559 2.22153C11.4124 2.07642 11.7035 2 12 2C12.2965 2 12.5876 2.07642 12.8441 2.22153C13.1005 2.36664 13.3132 2.57528 13.4604 2.82634L22.7731 18.5218C22.9215 18.7725 22.9997 19.0569 23 19.3464C23.0003 19.6359 22.9225 19.9204 22.7746 20.1714C22.6267 20.4224 22.4138 20.6311 22.1573 20.7765C21.9007 20.9219 21.6095 20.999 21.3127 21H2.68726C2.39055 20.999 2.09931 20.9219 1.84274 20.7765C1.58617 20.6311 1.37326 20.4224 1.22536 20.1714C1.07745 19.9204 0.999738 19.6359 1 19.3464C1.00026 19.0569 1.07849 18.7725 1.22686 18.5218ZM13 9C13 8.44772 12.5523 8 12 8C11.4477 8 11 8.44772 11 9V13C11 13.5523 11.4477 14 12 14C12.5523 14 13 13.5523 13 13V9ZM13.5 16.5C13.5 17.3284 12.8284 18 12 18C11.1716 18 10.5 17.3284 10.5 16.5C10.5 15.6716 11.1716 15 12 15C12.8284 15 13.5 15.6716 13.5 16.5Z",
    fill: "#FAB41C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttention);
export default __webpack_public_path__ + "static/media/attention.4ab4565dd1d096f153551da616887027.svg";
export { ForwardRef as ReactComponent };